// extracted by mini-css-extract-plugin
module.exports = {"container":"SessionExpiredWarning_container__x6sTA","heading":"SessionExpiredWarning_heading__25nEc"};